import React, { Component } from "react";
import { connect } from "react-redux";
import SponsorCta from "./SponsorCta";
import ChildBirthDate from "./ChildBirthDate";
import ChildDescriptors from "./ChildDescriptors";
import { childImage } from "../../utils/helpers.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faBirthdayCake } from "@fortawesome/free-solid-svg-icons";
import { isInteractiveKeyCode, noFuncProps } from "../../utils/helpers";
import { gtmTrackEventData } from "../../utils/gtm-event-triggers";
import { getAdditionalParams } from "../../utils/app-settings";
import { getSponsorshipMonthlyRate } from "../../config/rates";
const [TRACK, NO_TRACK] = [true, false];

class SpecialCircumstance extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <p className="special-circumstance">{this.props.text}</p>
    );
  }
}
class ChildTile extends Component {
  constructor(props) {
    super(props);
    this.sendCardClickAnalytics = this.sendCardClickAnalytics.bind(this);
    this.cardInputAction = this.cardInputAction.bind(this);
    this.cardInputActionKeyUp = this.cardInputActionKeyUp.bind(this);
    this.getCtaLink = this.getCtaLink.bind(this);
    this.goToCtaDestination = this.goToCtaDestination.bind(this);
    this.trackCtaClickAnalytics = this.trackCtaClickAnalytics.bind(this);

    this.state = {
      didReceiveStyle: false,
      ctaClass: "child-learn-more",
    };
  }

  getCtaLink() {
    const additionalParams = getAdditionalParams();
    return this.props.urlLink + additionalParams;
  }

  goToCtaDestination() {
    const ctaLink = this.getCtaLink();
    window.location.href = ctaLink;
  }

  sendCardClickAnalytics(event) {
    const textContent = event?.target?.alt || event.target?.textContent || event.target?.innerText || "";
    gtmTrackEventData("spon_app_card_click", {
      "search_props": noFuncProps(this.props),
      "search_params": noFuncProps(this.props.lastSearchKeyObj),
      "link_text": textContent
    });
  }

  trackCtaClickAnalytics(event) {
    gtmTrackEventData("spon_app_add_to_cart", {
      "search_props": noFuncProps(this.props),
      "sponsorship_monthly_rate": getSponsorshipMonthlyRate()
    });
  }

  cardInputAction(track = false) {
    return (event) => {
      if (this.props.childDetail) {
        track && this.trackCtaClickAnalytics();
        this.goToCtaDestination();
      } else if (this.props.changeView) {
        track && this.sendCardClickAnalytics(event);
        this.props.changeView(
          event, 
          this.props.identifier, 
          this.props.descriptorIndex
        );
      }
    };
  }

  cardInputActionKeyUp(track = false) {
    return (event) => {
      if (isInteractiveKeyCode(event)) {
        this.cardInputAction(track)(event);
      }
    };
  }

  handleKeyUp(e) {
    if (isInteractiveKeyCode(e)) {
      this.sendCardClickAnalytics(e);
      this.props.changeView
        ? this.props.changeView(
            e,
            this.props.identifier,
            this.props.descriptorIndex
          )
        : undefined;
    }
  }

  componentDidUpdate() {
    if (
      this.props.status == "COMPLETE" &&
      this.state.didReceiveStyle === false
    ) {
      this.setState({ didReceiveStyle: true });
      this.props.childDetail
        ? this.setState({ ctaClass: "sponsor-button" })
        : null;
    }
  }

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  }



  render() {
    if (this.props.status == "COMPLETE") {
      let daysWaiting = "";
      if (this.props.daysAwaitingSponsorshipCount > 364) {
        daysWaiting = "over 1\xa0year";
      } else if (this.props.daysAwaitingSponsorshipCount >= 60) {
        daysWaiting =
          Math.floor(this.props.daysAwaitingSponsorshipCount / 30) +
          "\xa0months";
      } else {
        daysWaiting = this.props.daysAwaitingSponsorshipCount + "\xa0days";
      }

      const isVowelSoundAge = (age) => ["8", "11", "18"].includes("" + age);

      let ageText = "";
      if (this.props.age === 0) {
        ageText = "baby";
      } else {
        ageText = this.props.age + "-year-old";
      }

      const birthdateData = this.formatDate(this.props.birthdate);
      const orphan =
        this.props.orphanFlag === true ? (
          <SpecialCircumstance type="orphan" text="I am an orphan" tooltip="" />
        ) : (
          ""
        );
      const disabled =
        this.props.disabledFlag === true ? (
          <SpecialCircumstance
            type="disabled"
            text="I have a disability"
            tooltip=""
          />
        ) : (
          ""
        );

      return (
        <div
          className={`card__wrapper child-tile child-index-${this.props.id} ${this.props.classList}`}
          data-child-identifier={this.props.identifier}
        >
            <div
              className="child-photo card__media zoom-hover--card zoom-hover__outer"
              onClick={this.cardInputAction(TRACK)}
              onKeyUp={this.cardInputActionKeyUp(TRACK)}
              tabIndex="0"
            >
              <img
                className="zoom-hover__inner card__media--img child-photo-thumb"
                src={childImage(this.props, this.props.childDetail)}
                alt={`Photo of ${this.props.givenName}`}
                width="480"
                height="640"
              />
            </div>
            <div className="child-info card__body"
                onClick={this.cardInputAction(TRACK)}
                onKeyUp={this.cardInputActionKeyUp(TRACK)}
            >
              <div
                className="child-name card__title epsilon"
                onClick={this.cardInputAction(NO_TRACK)}
                onKeyUp={this.cardInputActionKeyUp(NO_TRACK)}
                tabIndex="0">
                  {this.props.givenName}
                </div>

              <p className="child-birthday centi">
                <span className="cake">
                  <FontAwesomeIcon icon={faBirthdayCake} />
                </span>
                <span
                  className="child-birth-date"
                  data-child-birth-date={birthdateData}
                >
                  <ChildBirthDate dateVal={this.props.birthdate} />
                </span>
              </p>
              <p className="child-days-waiting centi">
                <span className="clock">
                  <FontAwesomeIcon icon={faClock} />
                </span>
                <span className="child-days-waiting-text">
                  waiting{" "}
                  <span className="child-days-waiting-number">
                    {daysWaiting}
                  </span>
                </span>
              </p>
              {orphan}
              {disabled}
              <p className="child-info__text">
                <span data-child-age={this.props.age} className="child-age">
                  {isVowelSoundAge(this.props.age) ? "An" : "A"}{" "}
                  <span className="child-age-number">{ageText}</span>
                </span>{" "}
                <span className="child-gender">
                  {this.props.gender === "Male" ? "boy" : "girl"}
                </span>{" "}
                from{" "}
                <span
                  className="child-country"
                  data-iso-code={this.props.countryCode}
                >
                  {this.props.countryName}{" "}
                  <ChildDescriptors
                    descriptorIndex={this.props.descriptorIndex}
                    descriptorsReceived={this.props.descriptorsReceived}
                  />
                </span>
              </p>
            </div>

            <SponsorCta
              fireAddToCart={this.props.fireAddToCart}
              handleHistory={this.props.addHistory}
              urlLink={this.props.urlLink}
              getCtaLink={this.getCtaLink}
              classList={[this.state.ctaClass]}
              sponsorshipTileCtaText={this.props.sponsorshipTileCtaText}
              changeView={this.props.changeView}
              identifier={this.props.identifier}
              descriptorIndex={this.props.descriptorIndex}
              angleRight={false}
              childInfoProps={this.props}
              trackCtaClickAnalytics={this.trackCtaClickAnalytics}
            />
        </div>
      );
    } else {
      return null;
    }
  }
}
function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps)(ChildTile);
